/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TenantOnPremEdrOrgSpec { 
    /**
     * The EDR region for on-premises deployment.
     */
    edr_region: string;
}

